module.exports = __webpack_public_path__ + "static/media/Group 2289.8f6526af.svg";